module.exports = {
    "ApiUrl": "https://rm-api-test12-ase.icarehealth.com.au/api/",
    "IdentityServerAuthority": "https://rm-identity-test12-ase-resman.icarehealth.com.au",
    "SignalRUrl": "https://rm-api-test12-ase.icarehealth.com.au/signalr",
    "AutomationEnabled": true,
    "MedicareTimeZone": "Australia/Melbourne"
};
